// extracted by mini-css-extract-plugin
export var button = "button-edit-module--button--M5V43";
export var gold = "button-edit-module--gold--ktsQX";
export var green = "button-edit-module--green--x2fcD";
export var icon = "button-edit-module--icon--RohOe";
export var red = "button-edit-module--red--GZZ-E";